import { render, staticRenderFns } from "./FormPhoto.vue?vue&type=template&id=529a6756&scoped=true&"
import script from "./FormPhoto.vue?vue&type=script&lang=tsx&"
export * from "./FormPhoto.vue?vue&type=script&lang=tsx&"
import style0 from "./FormPhoto.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FormPhoto.vue?vue&type=style&index=1&id=529a6756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a6756",
  null
  
)

export default component.exports